export default __webpack_public_path__ + "static/media/blocs.faf74af2.svg";